/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigScopeDetailsForTenant extends models.LockConfigScopeDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("LockConfigScopeDetailsForTenant");
    }

    getFixupPrototypeFunction() { return LockConfigScopeDetailsForTenant.fixupPrototype; }

    static newInstance(model: Partial<LockConfigScopeDetailsForTenant>): LockConfigScopeDetailsForTenant {
        let obj = Object.assign(new LockConfigScopeDetailsForTenant(), model);
        LockConfigScopeDetailsForTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigScopeDetailsForTenant>): LockConfigScopeDetailsForTenant {
        if (!model) return null;
        return LockConfigScopeDetailsForTenant.newInstance(<LockConfigScopeDetailsForTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigScopeDetailsForTenant) {
        if (!obj) return;

        models.LockConfigScopeDetailsForTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigScopeDetailsForTenant): boolean {
        if (models.LockConfigScopeDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LockConfigScopeDetailsForTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
